import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/basicActualWeather/sunriseSunset.png'


const _withScopeId = n => (_pushScopeId("data-v-47ff788e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "region-main" }
const _hoisted_3 = { class: "cityRegion" }
const _hoisted_4 = { class: "currentConditionHeader" }
const _hoisted_5 = { class: "currentConditionTimestamp" }
const _hoisted_6 = { class: "basicWeatherData" }
const _hoisted_7 = { class: "infoCurrentWeather" }
const _hoisted_8 = { class: "currentTemperature" }
const _hoisted_9 = { class: "temperatureStatus" }
const _hoisted_10 = { class: "maxMin" }
const _hoisted_11 = { class: "cards-climate weatherPreciseData" }
const _hoisted_12 = { class: "cityRegion" }
const _hoisted_13 = { class: "currentConditionHeader" }
const _hoisted_14 = { class: "basicWeatherData" }
const _hoisted_15 = { class: "infoCurrentWeather spaceCorrection" }
const _hoisted_16 = { class: "sunRiseSetImgTemperatureSensation" }
const _hoisted_17 = { class: "temperatureSensationContainer" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sensación Térmica", -1))
const _hoisted_19 = { class: "temperatureSensation" }
const _hoisted_20 = { class: "sunsetSunrise" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sunRiseSetImg",
  src: _imports_0,
  alt: "imgSunriseSunset"
}, null, -1))
const _hoisted_22 = { class: "sunsetSunrisetHours" }
const _hoisted_23 = { class: "detailInfoContainer" }
const _hoisted_24 = { class: "detailInfo" }
const _hoisted_25 = { class: "detailCommon" }
const _hoisted_26 = { class: "detailInfo" }
const _hoisted_27 = { class: "detailCommon" }
const _hoisted_28 = { class: "cards-climate weatherPreciseData" }
const _hoisted_29 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.bool)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("main", _hoisted_2, [
          _createElementVNode("section", {
            class: _normalizeClass(['cards-climate', _ctx.backgroundImageClass])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(_ctx.cityDataRef.name) + " - " + _toDisplayString(_ctx.cityDataRef.country) + " / ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentTime.hour) + ":" + _toDisplayString(_ctx.currentTime.minute) + " " + _toDisplayString(_ctx.currentTime.ampm), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.cityValuesRef.current_weather.temperature) + "°", 1),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.weatherCode), 1)
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("b", null, "Max " + _toDisplayString(_ctx.cityValuesRef.daily.temperature_2m_max[0]) + " °", 1),
                  _createTextVNode(" "),
                  _createElementVNode("b", null, " Min " + _toDisplayString(_ctx.cityValuesRef.daily.temperature_2m_min[0]) + "°", 1)
                ])
              ])
            ])
          ], 2),
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h2", null, "Tiempo detallado en " + _toDisplayString(_ctx.cityDataRef.name) + " - " + _toDisplayString(_ctx.cityDataRef.country), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("b", _hoisted_19, _toDisplayString(_ctx.cityValuesRef.hourly.apparent_temperature[_ctx.currentTime.hour]) + "°", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.sunriseTime), 1)
                      ]),
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.sunsetTime), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propiedadesComunes, (value, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: value }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.propiedadesComunesEspacios[index]), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.cityValuesRef.hourly[value][_ctx.currentTime.hour]) + _toDisplayString(_ctx.cityValuesRef.hourly_units[value]), 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propiedadesMenosComunes, (value, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: value }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.propiedadesMenosComunesEspacios[index]), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.cityValuesRef.hourly[value][_ctx.currentTime.hour]) + " " + _toDisplayString(_ctx.cityValuesRef.hourly_units[value]), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("h1", null, [
                  _createVNode(_component_router_link, {
                    class: "goDetails",
                    to: "/about"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ver más")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_28, [
            _createElementVNode("iframe", {
              style: {"width":"100%","height":"400px"},
              src: 'https://maps.google.com/maps?q=' + _ctx.cityValuesRef.latitude + ',' + _ctx.cityValuesRef.longitude + '&hl=es;z=14&output=embed'
            }, null, 8, _hoisted_29)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}